module.exports = __webpack_public_path__ + "img/warning-big.32062c17.svg";